"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptInput = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
require("@/components/overlay/popover/popover");
const utils_1 = require("@/utils");
require("@/components/domains/chat/model-selector");
let PromptInput = class PromptInput extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.name = '';
        this.placeholder = 'Ask me anything...';
        this.model = 'claude-sonnet';
        this.submitLabel = '전송';
        this.loading = false;
        // popover는 portal로 옮겨져 한 트리에 모이므로, 인스턴스가 여럿이어도 id가 겹치지 않게 한다.
        this.attachMenuId = (0, utils_1.uniqueId)('attach-menu');
        this.handleTextareaInput = (e) => {
            e.stopPropagation();
            this.value = e.detail.value;
            (0, utils_1.emit)(this, 'input', { value: this.value });
        };
        this.handleTextareaKeydown = (e) => {
            // 슬롯에 둔 툴바 버튼의 키 입력도 mm-textarea를 거쳐 올라오므로 입력 영역에서 온 것만 받는다.
            if (e.target !== e.currentTarget)
                return;
            if (e.isComposing)
                return;
            if (e.key !== 'Enter' || e.shiftKey)
                return;
            e.preventDefault();
            this.handleSubmitClick();
        };
        this.handleSubmitClick = () => {
            if (this.loading || !this.value.trim())
                return;
            (0, utils_1.emit)(this, 'submit', { value: this.value, model: this.model });
        };
    }
    render() {
        return (0, lit_1.html) `
      <form>
        <mm-textarea
          .value=${this.value}
          .name=${this.name}
          .placeholder=${this.placeholder}
          ?disabled=${this.loading}
          @input=${this.handleTextareaInput}
          @keydown=${this.handleTextareaKeydown}
        >
          <div slot="trailing" class="toolbar">
            ${this.renderStartActions()} ${this.renderEndActions()}
          </div>
        </mm-textarea>
      </form>
    `;
    }
    renderStartActions() {
        return (0, lit_1.html) `
      <div class="actions">
        <mm-icon-button
          icon=${common_1.ICON_NAMES.ADD_CIRCLE}
          aria-label="이미지 첨부"
          aria-haspopup="menu"
          aria-controls=${this.attachMenuId}
        ></mm-icon-button>
        <mm-popover id=${this.attachMenuId} placement="top-start">
          <mm-menu-item-group aria-label="이미지 첨부">
            <mm-menu-item-action
              icon=${common_1.ICON_NAMES.IMPORT}
              label="이미지 업로드"
            ></mm-menu-item-action>
            <mm-menu-item-action
              icon=${common_1.ICON_NAMES.CAMERA}
              label="카메라 촬영"
            ></mm-menu-item-action>
            <mm-menu-item-action icon=${common_1.ICON_NAMES.LINK} label="URL로 추가"></mm-menu-item-action>
          </mm-menu-item-group>
        </mm-popover>
        <slot name="leading-actions"></slot>
        <!-- <mm-model-selector></mm-model-selector> -->
      </div>
    `;
    }
    renderEndActions() {
        return (0, lit_1.html) `
      <div class="actions">
        <slot name="trailing-actions"></slot>
        <mm-icon-button
          variant="primary"
          icon=${common_1.ICON_NAMES.SUBMIT}
          aria-label=${this.submitLabel}
          ?disabled=${this.loading}
          @click=${this.handleSubmitClick}
        ></mm-icon-button>
      </div>
    `;
    }
};
PromptInput.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    .toolbar {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
    }

    .actions {
      display: flex;
      align-items: center;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PromptInput.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PromptInput.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PromptInput.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PromptInput.prototype, "model", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'submit-label' })
], PromptInput.prototype, "submitLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], PromptInput.prototype, "loading", void 0);
PromptInput = __decorate([
    (0, decorators_js_1.customElement)('mm-prompt-input')
], PromptInput);
exports.PromptInput = PromptInput;
//# sourceMappingURL=data:application/json;base64,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